import { CheckboxField, DateField, DropdownField, LongTextField, NumberField, RadioField, ShortTextField, serializeCheckboxField, serializeDropdownField, serializeRadioField, validateCheckboxField, validateDateField, validateDropdownField, validateLongTextField, validateNumberField, validateRadioField, validateShortTextField, } from "./fields";
import { FileField, validateFileField } from "./fields/FileField";
export const fieldRegistry = {
    file: {
        renderer: FileField,
        validator: validateFileField,
    },
    shortText: {
        renderer: ShortTextField,
        validator: validateShortTextField,
    },
    longText: {
        renderer: LongTextField,
        validator: validateLongTextField,
    },
    number: {
        renderer: NumberField,
        validator: validateNumberField,
    },
    dropdown: {
        renderer: DropdownField,
        validator: validateDropdownField,
        serializer: serializeDropdownField,
    },
    radio: {
        renderer: RadioField,
        validator: validateRadioField,
        serializer: serializeRadioField,
    },
    checkbox: {
        renderer: CheckboxField,
        validator: validateCheckboxField,
        serializer: serializeCheckboxField,
    },
    date: {
        renderer: DateField,
        validator: validateDateField,
    },
};
//# sourceMappingURL=fieldRegistry.js.map